/**
 * @generated SignedSource<<dc60ceb9848c2d5f0b2edd6f4c91c245>>
 * @relayHash 94224d70a7ea49ef4f015a428e9cf943
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94224d70a7ea49ef4f015a428e9cf943

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useChatMessagesQuery$variables = {
  threadId: string;
};
export type useChatMessagesQuery$data = {
  readonly chatMessages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: string | null;
        readonly createdOn: string;
        readonly id: string;
        readonly metadata: {
          readonly aiFeatures: string | null;
          readonly autoTranslationBackTranslatedContent: string | null;
          readonly autoTranslationFailed: boolean | null;
          readonly autoTranslationOriginalContent: string | null;
          readonly autoTranslationTargetLanguage: Language | null;
          readonly autoTranslationTranslatedContent: string | null;
          readonly originalContent: string | null;
          readonly senderUserName: string | null;
        } | null;
        readonly participants: ReadonlyArray<{
          readonly displayName: string | null;
          readonly id: string | null;
        }>;
        readonly senderDisplayName: string | null;
        readonly senderId: string | null;
        readonly type: string;
      };
    }> | null;
  } | null;
};
export type useChatMessagesQuery = {
  response: useChatMessagesQuery$data;
  variables: useChatMessagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "threadId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "threadId",
    "variableName": "threadId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ChatMessageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatMessage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderDisplayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessageMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiFeatures",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "senderUserName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoTranslationOriginalContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoTranslationTranslatedContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoTranslationBackTranslatedContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoTranslationTargetLanguage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoTranslationFailed",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessageParticipant",
            "kind": "LinkedField",
            "name": "participants",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChatMessagesQuery",
    "selections": [
      {
        "alias": "chatMessages",
        "args": (v1/*:: as any*/),
        "concreteType": "ChatMessageConnection",
        "kind": "LinkedField",
        "name": "__ChatMessages_chatMessages_connection",
        "plural": false,
        "selections": (v3/*:: as any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChatMessagesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ChatMessageConnection",
        "kind": "LinkedField",
        "name": "chatMessages",
        "plural": false,
        "selections": (v3/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": [
          "threadId"
        ],
        "handle": "connection",
        "key": "ChatMessages_chatMessages",
        "kind": "LinkedHandle",
        "name": "chatMessages"
      }
    ]
  },
  "params": {
    "id": "94224d70a7ea49ef4f015a428e9cf943",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "chatMessages"
          ]
        }
      ]
    },
    "name": "useChatMessagesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cf3677ea56b7f42719e1d38fa73bde35";

export default node;
